// Attentive Product View Event
{
    window.initAttentiveSwatchEvents = () => {
        let swatches = document.querySelectorAll('.js-attentive-event-swatch');
        if(swatches.length > 0) {
            swatches.forEach((swatch) => {
                if (swatch.dataset.attentiveBound === 'true') return;
                swatch.dataset.attentiveBound = 'true';
                swatch.addEventListener('click', () => {
                    let productId = swatch.getAttribute('data-event-product-id') || '';
                    let variantId = swatch.getAttribute('data-variant-id') || '';
                    let productName = swatch.getAttribute('data-event-product-name') || '';
                    let productCategory = swatch.getAttribute('data-event-product-category') || '';
                    let productImg = swatch.getAttribute('data-event-product-img') || '';
                    let variantPrice = (parseInt(swatch.getAttribute('data-price') || 0, 10) / 100).toFixed(2);
    
                    window.attentive.analytics.productView(
                        {
                            items: [
                                {
                                    productId: productId,
                                    productVariantId: variantId,
                                    name: productName,
                                    productImage: productImg,
                                    category: productCategory,
                                    price: {
                                        value: variantPrice,
                                        currency: window.shop_currency || 'USD',
                                    },
                                    quantity: 1,
                                }
                            ], 
                            user: {
                                phone: window.user_phone || '',
                            }
                        }
                    );
                });
            });
        }
    };
    window.initAttentiveSwatchEvents();
}